export const getScrollParent = (element: HTMLElement): Element | Window => {
  let parent = element.parentElement;
  while (parent && parent !== document.documentElement) {
    const style = window.getComputedStyle(parent);
    if (
      /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX)
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return window;
};
